import { render } from "./brand.vue?vue&type=template&id=279f3cb7&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"

import "./brand.vue?vue&type=style&index=0&id=279f3cb7&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279f3cb7"]])

export default __exports__